/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CommitPlayerSelectionChangesInput = {|
  greenMachineSessionId?: ?string,
  addPlayers: $ReadOnlyArray<?string>,
  removePlayers: $ReadOnlyArray<?string>,
  selectAll?: ?boolean,
  deselectAll?: ?boolean,
  clientMutationId?: ?string,
|};
export type CommitPlayerSelectionChangesMutationVariables = {|
  input: CommitPlayerSelectionChangesInput
|};
export type CommitPlayerSelectionChangesMutationResponse = {|
  +commitPlayerSelectionChanges: ?{|
    +success: ?boolean
  |}
|};
export type CommitPlayerSelectionChangesMutation = {|
  variables: CommitPlayerSelectionChangesMutationVariables,
  response: CommitPlayerSelectionChangesMutationResponse,
|};
*/


/*
mutation CommitPlayerSelectionChangesMutation(
  $input: CommitPlayerSelectionChangesInput!
) {
  commitPlayerSelectionChanges(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CommitPlayerSelectionChangesPayload",
    "kind": "LinkedField",
    "name": "commitPlayerSelectionChanges",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommitPlayerSelectionChangesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommitPlayerSelectionChangesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e1365047b153ee22ff8210243423040b",
    "id": null,
    "metadata": {},
    "name": "CommitPlayerSelectionChangesMutation",
    "operationKind": "mutation",
    "text": "mutation CommitPlayerSelectionChangesMutation(\n  $input: CommitPlayerSelectionChangesInput!\n) {\n  commitPlayerSelectionChanges(input: $input) {\n    success\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9ba81be32c039941bac8d47be535ea45';

module.exports = node;
